type Props = { label: string; value: string; accent?: string };

export function StatChip({ label, value, accent }: Props) {
  return (
    <div
      style={{
        flex: 1,
        padding: '12px 14px',
        background: 'var(--bg-card)',
        borderRadius: 16,
        border: '1px solid var(--border)',
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: 'var(--text-3)',
          textTransform: 'uppercase',
          letterSpacing: 0.04,
        }}
      >
        {label}
      </div>
      <div
        className="lt-serif lt-tabular"
        style={{
          fontSize: 22,
          lineHeight: 1.05,
          marginTop: 4,
          color: accent ? `var(--${accent})` : 'var(--text-1)',
          letterSpacing: -0.01,
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </div>
    </div>
  );
}
